module.exports = __webpack_public_path__ + "static/media/m_product_guide.6fe426fd.png";